import { Injectable } from '@angular/core'
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { Observable, of, Subject } from 'rxjs'
import { map } from 'rxjs/operators'
import { environment } from '../../../../environments/environment'

@Injectable({
  providedIn: 'root',
})
export class SpasLicenseService {
  private static licenseDetails: {
    is_active: boolean
    insert_date: string
    modules: any[]
    objects: any[]
  }
  private static licenseStatus: { installed: boolean; warnings: number; alerts: number }
  private apiURL: string = environment.apiUrl + '/admin/plant-setup/spas-license'

  private _licenseChangeEvent: Subject<boolean> = new Subject<boolean>()

  public get licenseChangeEvent(): Subject<boolean> {
    return this._licenseChangeEvent
  }

  public notifyLicenseChange(): void {
    this._licenseChangeEvent.next(true)
  }

  constructor(private http: HttpClient) {}

  private getHeaders(): HttpHeaders {
    return new HttpHeaders().set('Content-Type', 'application/json')
  }

  public getLicenseDetails(): Observable<{
    is_active: boolean
    insert_date: string
    modules: any[]
    objects: any[]
  }> {
    if (SpasLicenseService.licenseDetails) {
      return of(SpasLicenseService.licenseDetails)
    }
    const url = this.apiURL + '/license/details'
    return this.http.get(url, { headers: this.getHeaders() }).pipe(
      map((resource: any) => {
        SpasLicenseService.licenseDetails = resource
        return SpasLicenseService.licenseDetails
      }),
    )
  }

  public getLicenseStatus(
    reload: boolean = false,
  ): Observable<{ installed: boolean; warnings: number; alerts: number }> {
    if (SpasLicenseService.licenseStatus && !reload) {
      return of(SpasLicenseService.licenseStatus)
    }
    const url = this.apiURL + '/license/status'
    return this.http.get(url, { headers: this.getHeaders() }).pipe(
      map((resource: { installed: boolean; warnings: number; alerts: number }) => {
        SpasLicenseService.licenseStatus = resource
        return SpasLicenseService.licenseStatus
      }),
    )
  }

  public getLicensePublicKeyStatus(): Observable<{ has_public_key: boolean }> {
    const url = this.apiURL + '/license/public-key/status'
    return this.http.get(url, { headers: this.getHeaders() }).pipe(
      map((resource: { has_public_key: boolean }) => {
        return resource
      }),
    )
  }

  public saveLicensePublicKey(publicKey: string): Observable<any> {
    const url = this.apiURL + '/license/public-key'
    return this.http.post(url, { key: publicKey }, { headers: this.getHeaders() }).pipe(
      map((resource: any) => {
        return resource
      }),
    )
  }

  public saveLicense(license: string): Observable<{
    is_active: boolean
    insert_date: string
    modules: any[]
    objects: any[]
  }> {
    const url = this.apiURL + '/license'
    return this.http.post(url, { key: license }, { headers: this.getHeaders() }).pipe(
      map((resource: any) => {
        return resource
      }),
    )
  }
}
